import { render, staticRenderFns } from "./VerificationHistory.vue?vue&type=template&id=23b4beae&scoped=true"
import script from "./VerificationHistory.vue?vue&type=script&lang=ts"
export * from "./VerificationHistory.vue?vue&type=script&lang=ts"
import style0 from "./VerificationHistory.vue?vue&type=style&index=0&id=23b4beae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4beae",
  null
  
)

export default component.exports